export default {
    loading_content: "Estamos a fazer o upload do seu conteúdo",
    wellcome: "¡Bem-vindo a BrainsPro!",
    redirect_academy: "Dentro de alguns momentos será redireccionado para a sua academia.",
    first: "Primeiro",
    last: "Último",
    next: "Próximo",
    page: "Página",
    previous: "Anterior",

    // PaginationControls
    pagination: 'Paginação',
    showing_results: 'A mostrar {from}-{to} de {total}',
    page_of: 'Página {page} de {pages}',
    go_to_page: 'Ir para a página {page}',
}
